import React from "react";

import {
    YES_NO_CHOICE_OPTIONS
} from "@constants/dropdown-choices";


import PolicyHolderAccidentForm from "../common/policy-holder-accident-form";
import {ValidateStep4Data} from "@validators/car-insurance-form/step4-validator";
import {showValidationErrorsModal} from "@utils/modal-manager";
import SectionHeading from "@components/common/ui-elements/headings/section-heading";

import ScrollableButtonGroupBlock from "@components/common/form-blocks/scrollable/button-group-block";
import AddItemButtonComponent from "@components/common/form-controls/buttons/add-item-button";
import PreviousButtonComponent from "@components/common/form-controls/buttons/previous-button";
import NextButtonComponent from "@components/common/form-controls/buttons/next-button";
import PolicyHolderConvictionForm from "../common/policy-holder-conviction-form";
import {WizardStepButtonsBlock} from "@components/common/form-blocks/other/wizard-step-buttons-block";


export default function IF_Step3(
    {
        data,
        handlers,
        setCurrentStep,
        handlePolicyHolderAccidentPropChange,
        handlePolicyHolderConvictionPropChange,
        addPolicyHolderAccident,
        addPolicyHolderConviction,
        removePolicyHolderAccident,
        removePolicyHolderConviction,
    }
) {

    const STEP = 4;

    const onPrevBtnClick = (event) => {

        setCurrentStep(STEP - 1);

    }

    function onNextBtnClick() {

        let validationResult = ValidateStep4Data(data);

        if (validationResult.length) {

            showValidationErrorsModal({
                validationResult: validationResult
            });


        } else {
            setCurrentStep(STEP + 1);
        }


    }


    return (
        <div className={`if-step-${STEP}`}>

            {/*
                Claims and convictions ...
            */}

            <SectionHeading
                text="Claims & convictions"
            />

            <div className="row">

                {/* Any motor accidents or claims in the last 5 years? */}

                <ScrollableButtonGroupBlock
                    containerCssClass="col-12 py-3 "
                    labelText="Any motor accidents, claims or only notification in last five years regardless of claim made or not?"
                    required={true}
                    controlName="hasAccidentClaimsInLast5Years"
                    options={YES_NO_CHOICE_OPTIONS}
                    selectedValues={data.hasAccidentClaimsInLast5Years}
                    onChange={handlers.onControlChange}
                />

            </div>

            {data.hasAccidentClaimsInLast5Years === 'Yes' && data.motorAccidentsList.length !== 0 && (

                <div className="row hidden-box">

                    <div className="col-12 py-3 gap-3 d-flex flex-column">

                        {data.motorAccidentsList?.map((accident, accidentIndex) => (
                            <PolicyHolderAccidentForm
                                key={accidentIndex}
                                accidentIndex={accidentIndex}
                                accident={accident}
                                motorAccidentsListPropName={`motorAccidentsList`}
                                handlePolicyHolderAccidentPropChange={handlePolicyHolderAccidentPropChange}
                                addPolicyHolderAccident={addPolicyHolderAccident}
                                removePolicyHolderAccident={removePolicyHolderAccident}
                            />
                        ))}

                    </div>


                </div>

            )}

            {data.hasAccidentClaimsInLast5Years === 'Yes'
            && data.motorAccidentsList.length === 0
            && (

                <div className="row">
                    <div className="col-12 py-3 text-danger scrollable" data-block="motorAccidentsList">
                        No accident record submitted yet!
                    </div>
                </div>

            )}

            {data.hasAccidentClaimsInLast5Years === 'Yes' && (

                <div className="row">
                    <div className="col-12 py-3 text-center">
                        <AddItemButtonComponent
                            text="Add Incident"
                            onClick={(e) => addPolicyHolderAccident()}
                        />
                    </div>
                </div>


            )}

            <div className="row">

                {/* Any motoring convictions, driving licence endorsements or fixed penalty points within the last 5
                        years? */}

                <ScrollableButtonGroupBlock
                    containerCssClass="col-12 py-3 extra"
                    labelText="Any motoring convictions, driving licence endorsements or fixed penalty points within the last 5 years?"
                    required={true}
                    controlName="hasMotoringConvictionsInLast5Years"
                    options={YES_NO_CHOICE_OPTIONS}
                    selectedValues={data.hasMotoringConvictionsInLast5Years}
                    onChange={handlers.onControlChange}
                />

            </div>

            {data.hasMotoringConvictionsInLast5Years === 'Yes'
            && data.motorConvictionsList.length !== 0
            && (

                <div className="row hidden-box">

                    <div className="col-12 py-3 gap-3 d-flex flex-column">

                        {data.motorConvictionsList?.map((conviction, convictionIndex) => (
                            <PolicyHolderConvictionForm
                                key={convictionIndex}
                                convictionIndex={convictionIndex}
                                conviction={conviction}
                                motorConvictionsListPropName={`motorConvictionsList`}
                                handlePolicyHolderConvictionPropChange={handlePolicyHolderConvictionPropChange}
                                addPolicyHolderConviction={addPolicyHolderConviction}
                                removePolicyHolderConviction={removePolicyHolderConviction}
                            />
                        ))}

                    </div>


                </div>

            )}

            {data.hasMotoringConvictionsInLast5Years === 'Yes'
            && data.motorConvictionsList.length === 0
            && (

                <div className="row">
                    <div className="col-12 py-3 text-danger scrollable" data-block="motorConvictionsList">
                        No conviction record submitted yet!
                    </div>
                </div>

            )}

            {data.hasMotoringConvictionsInLast5Years === 'Yes' && (

                <div className="row">
                    <div className="col-12 py-3 text-center">
                        <AddItemButtonComponent
                            text="Add Conviction"
                            onClick={(e) => addPolicyHolderConviction()}
                        />
                    </div>
                </div>

            )}

            {/*
                Step buttons ....
            */}

            {/*<div className="row mt-5">
                <div className="col-12 d-flex justify-content-between">

                    <PreviousButtonComponent
                        onClick={onPrevBtnClick}
                    />

                    <NextButtonComponent
                        onClick={onNextBtnClick}
                    />
                </div>
            </div>*/}
           
           <WizardStepButtonsBlock
              onPrevBtnClick={onPrevBtnClick}
              onNextBtnClick={onNextBtnClick}
              nextButtonAdditionalCssClass={``}
           />

        </div>
    )
}